<section class="agpr-monitoring">
    <header class="u-srOnly">
        <h1>
            {{ 'AMT' | localize }}
        </h1>
    </header>
</section>
<agpr-master-layout [layout]="layout">
    <ng-template let-item agprTemplate="navigation">
        <agpr-left-sidebar [hideManageListDialog]="true"></agpr-left-sidebar>
    </ng-template>
</agpr-master-layout>
